/**
 * Bilingual copy for the Demo page.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 * Demo credentials/urls are kept in DemoPage.tsx itself.
 */
export const en = {
  eyebrow: 'Demo Environment',
  title: 'Full Featured Demo',
  description:
    'Open a live demo and click around — no signup needed. HR, clinic, and store demos are ready to try with the credentials below.',
  usernameLabel: 'Username:',
  passwordLabel: 'Password:',
  openDemo: 'Open Demo',
  items: [
    {
      key: 'frontStore',
      title: 'Front Store Demo',
      description:
        'Customer-facing AKAS online store: catalog, browsing, and checkout on the same items as the ERP.',
    },
    {
      key: 'storeAdmin',
      title: 'Store Admin Demo',
      description: 'Store admin: products, banners, payments, and day-to-day storefront setup.',
    },
    {
      key: 'hrSystem',
      title: 'HR System Demo',
      description: 'HRMS self-service, personnel, leave, attendance, and payroll screens.',
    },
    {
      key: 'clinic',
      title: 'Clinic Demo',
      description: 'Clinic queue, consultation, dispensary, and payment on a live demo.',
    },
  ],
};

export type Copy = typeof en;

export const km: Copy = {
  eyebrow: 'បរិស្ថាន Demo',
  title: 'Demo មុខងារពេញលេញ',
  description:
    'បើក Demo ផ្ទាល់ ហើយចុចសាកល្បង — មិនចាំបាច់ចុះឈ្មោះទេ។ Demo ធនធានមនុស្ស គ្លីនិក និងហាង ត្រូវបានរៀបចំរួច ដើម្បីសាកល្បងជាមួយព័ត៌មានចូលប្រើខាងក្រោម។',
  usernameLabel: 'ឈ្មោះអ្នកប្រើប្រាស់៖',
  passwordLabel: 'ពាក្យសម្ងាត់៖',
  openDemo: 'បើក Demo',
  items: [
    {
      key: 'frontStore',
      title: 'Demo ហាងអនឡាញ',
      description:
        'ហាងអនឡាញ AKAS សម្រាប់អតិថិជន៖ កាតាឡុក ការរុករក និងការទូទាត់លើទំនិញដូចក្នុង ERP។',
    },
    {
      key: 'storeAdmin',
      title: 'Demo អ្នកគ្រប់គ្រងហាង',
      description: 'ផ្ទៃអ្នកគ្រប់គ្រងហាង៖ ទំនិញ បដា ការទូទាត់ និងការរៀបចំហាងប្រចាំថ្ងៃ។',
    },
    {
      key: 'hrSystem',
      title: 'Demo ប្រព័ន្ធធនធានមនុស្ស',
      description: 'អេក្រង់ HRMS សេវាកម្មបុគ្គលិកដោយខ្លួនឯង ការគ្រប់គ្រងបុគ្គលិក ការឈប់សម្រាក វត្តមាន និងប្រាក់ខែ។',
    },
    {
      key: 'clinic',
      title: 'Demo គ្លីនិក',
      description: 'ជួរអ្នកជំងឺ ការពិគ្រោះព្យាបាល ការចេញឱសថ និងការទូទាត់ក្នុង Demo ផ្ទាល់។',
    },
  ],
};
